<template>
  <div class="container">
    <div class="card card-custom gutter-b">
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark"
            >Business Information</span
          >
        </h3>
        <!--        <div class="card-toolbar">-->
        <!--          <a class="align-self-start btn btn-sm btn-light-success font-weight-bolder text-uppercase mr-3" href="#">Reports</a>-->
        <!--          <a class="align-self-start btn btn-sm btn-info font-weight-bolder text-uppercase" href="#">New Task</a>-->
        <!--        </div>-->
      </div>
      <div class="card-body pt-0">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="d-flex">
              <div class="flex-grow-1 d-flex ">
                <div class="d-flex flex-column flex-root text-dark-75">
                  <span class="font-weight-bolder mb-1">TIN</span>
                  <span class="font-weight-bolder font-size-h5"
                    >007-484-999-000</span
                  >
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">RDO Code</span>
                  <span class="opacity-70">050 Makati</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  &nbsp;
                </div>
              </div>
            </div>
            <div>
              <div class="d-flex justify-content-between pt-6">
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Business Name</span>
                  <span class="opacity-70">Tantamco Bottling</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Registered Name</span>
                  <span class="opacity-70">Tantamco Bottling</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Business Address</span>
                  <span class="opacity-70"
                    >#77 Bayani St. Metro Manila 1227</span
                  >
                </div>
              </div>
              <div class="d-flex justify-content-between pt-6">
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Mobile Number</span>
                  <span class="opacity-70">0900-000-0000</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Landline</span>
                  <span class="opacity-70">(02) 8444-9595</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Email Address</span>
                  <span class="opacity-70">abc@thirdchannel.ph</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-custom gutter-b">
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark"
            >ATG Application</span
          >
        </h3>
        <div class="card-toolbar">
          <a
            class="align-self-start btn btn-sm btn-light-success font-weight-bolder text-uppercase mr-3"
            href="#"
            >Download Form</a
          >
          <a
            class="align-self-start btn btn-sm btn-info font-weight-bolder text-uppercase"
            href="#"
            >Send Message</a
          >
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="d-flex">
          <div class="flex-grow-1">
            <div class="d-flex align-items-center flex-wrap">
              <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
                <span class="mr-4">
                  <i
                    class="flaticon2-writing icon-2x text-muted font-weight-bold"
                  ></i>
                </span>
                <div class="d-flex flex-column text-dark-75">
                  <span class="font-weight-bolder font-size-sm">OCN</span>
                  <span class="font-weight-bolder font-size-h5"
                    >10G232389283</span
                  >
                </div>
              </div>
              <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
                <span class="mr-4">
                  <i
                    class="flaticon2-calendar-9 icon-2x text-muted font-weight-bold"
                  ></i>
                </span>
                <div class="d-flex flex-column text-dark-75">
                  <span class="font-weight-bolder font-size-sm"
                    >Submission Date</span
                  >
                  <span class="font-weight-bolder font-size-h5"
                    >August 29, 2020</span
                  >
                </div>
              </div>
              <div class="d-flex align-items-center flex-lg-fill mr-5 my-1">
                <span class="mr-4">
                  <i
                    class="flaticon-globe icon-2x text-muted font-weight-bold"
                  ></i>
                </span>
                <div class="d-flex flex-column text-dark-75">
                  <span class="font-weight-bolder font-size-sm">Status</span>
                  <span class="font-weight-bolder font-size-h5"
                    >For Review</span
                  >
                </div>
              </div>
            </div>
            <div class="separator separator-solid my-7"></div>
            <div>
              <div class="d-flex justify-content-between">
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Business Name</span>
                  <span class="opacity-70">Tantamco Bottling</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Registered Name</span>
                  <span class="opacity-70">Tantamco Bottling</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Business Address</span>
                  <span class="opacity-70"
                    >#77 Bayani St. Metro Manila 1227</span
                  >
                </div>
              </div>
              <div class="d-flex justify-content-between pt-6">
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Mobile Number</span>
                  <span class="opacity-70">0900-000-0000</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Landline</span>
                  <span class="opacity-70">(02) 8444-9595</span>
                </div>
                <div class="d-flex flex-column flex-root">
                  <span class="font-weight-bolder mb-1">Email Address</span>
                  <span class="opacity-70">abc@thirdchannel.ph</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";

Vue.use(require("vue-moment"));
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isBusy: false,
      tabIndex: 0,
      current: {
        property: null
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setBreadcrumbs("10G7U20809");
      // this.getData(this.id)
      //     .then(data => {
      //       this.setBreadcrumbs(data.PropertyIdentifier);
      //     })
      //     .catch();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Authority to Generate",
          route: "/easyreceipt"
        },
        {
          title: "ATG Applications",
          route: "/easyreceipt/applications"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    getData(id) {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = { PropertyId: id };
        ApiService.get("properties/getbyid", param)
          .then(({ data }) => {
            self.current.property = data;
            self.isBusy = false;
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    }
  },
  watch: {}
};
</script>
